import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { openNotification } from "src/components/helpers/notification"
import ax from "src/store/config"

const initialState = {
  certificatesList: null,
  certificatesListLoading: false,
  mnemo: null,
}

export const getCertificates = createAsyncThunk(
  'certificates/getCertificates',
  async(payload, { rejectWithValue }) => {
    try{
      const { data } = await ax.get("api/admin/directory/abonementCertificates", {
        params: {
          ...payload?.value,
          seeCode: payload?.seeCode 
        }
      })
      return data
    } catch(error) {
      openNotification('error', 'Ошибка', `Ошибка ${error.response?.data?.errorMessages?.[0]?.errorCode}. ${error.response?.data?.errorMessages?.[0]?.errorMessage}`)
      return rejectWithValue(error.response?.data)
    }
  }
)

const CertificatesSlice = createSlice({
  name: "Certificates",
  initialState,
  reducers: {
    setCertificatesListLoading: (state, action) => {
      state.certificatesListLoading = action.payload
    },
    setMnemo: (state, action) => {
      state.mnemo = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCertificates.pending, (state) => {
      state.certificatesListLoading = true
    })
    builder.addCase(getCertificates.fulfilled, (state, action) => {
      state.certificatesListLoading = false
      state.certificatesList = action.payload
    })
    builder.addCase(getCertificates.rejected, (state) => {
      state.certificatesListLoading = false
    })
  }
})

export const { setCertificatesListLoading, setMnemo } = CertificatesSlice.actions
export default CertificatesSlice.reducer